import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getCurrentAd } from '../../../selectors'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'
import { conditions } from 'SRC/modules/ads/shared/constants/conditions'

const Condition = ({ad, category}) => {
  return ad.condition && category && category.condition ? <li>
    <p>Stanje artikla:</p>
    <span>{conditions[ad.condition.toUpperCase()].label}</span>
  </li> : null
}

const mapStateToProps = state => ({
  ad: getCurrentAd(state),
  category: getCurrentSubCategory(state)
})

Condition.propTypes = {
  ad: PropTypes.shape({
    condition: PropTypes.string
  }).isRequired,
  category: PropTypes.shape({
    condition: PropTypes.bool
  }).isRequired
}

export default connect(mapStateToProps)(Condition)
